import { getListAPI, postFormAPI, putSomeAPI, deleteListAPI } from '@/request/Public/axiosApi';

// 请求全部字典
export function CommonDict(data) {
  return getListAPI('/exhibition/api/common/dict', data);
}
